import { useGroups } from '@/hooks';
import { listGroupLabels, log } from '@/utils';
import { Done as DoneIcon } from '@mui/icons-material';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useParams } from 'react-router';

export function Placeholder({ id, title, groupCodes, onComplete }) {
  const {
    query: { data: groups },
  } = useGroups({ type: ['SECTOR', 'TEAM'] });
  const { code } = useParams();

  function handleClick() {
    log('View', title ?? id, { code, groupCodes });
    onComplete();
  }

  return (
    <Box sx={{ px: 1 }}>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: 'center',
          position: 'sticky',
          top: 48,
          bgcolor: 'background.default',
          zIndex: 700,
          pl: 1,
          py: 1,
        }}
      >
        <Typography variant="h6">{title}</Typography>
        <Box>
          <Tooltip title="Done" placement="right">
            <IconButton onClick={handleClick}>
              <DoneIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Box>
      </Stack>
      <Stack spacing={1} sx={{ pb: 1 }}>
        <Typography sx={{ p: 1 }}>
          This is a placeholder for section {title} for{' '}
          {groups && listGroupLabels('Group', groupCodes, groups)}
        </Typography>
      </Stack>
    </Box>
  );
}
